import { MenuItemsType, DropdownMenuItemType } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'

export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean }

const config: (t: ContextApi['t']) => ConfigMenuItemsType[] = (t) => [
  {
    label: t('Swap'),
    icon: 'Swap',
    href: '/swap',
    showItemsOnMobile: true,
    items: [
      {
        label: t('Swap'),
        href: '/swap',
      },
    ],
  },
  {
    label: t('Pool'),
    href: '/pool',
    icon: 'Pool',
    items: [
      {
        label: t('Pool'),
        href: '/pool',
      },
    ],
  },
  {
    label: '',
    href: '/swap',
    icon: 'More',
    hideSubNav: true,
    items: [
      {
        label: t('Dashboard'),
        href: 'https://dash.doge.ceo/',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('V2 Migration'),
        href: 'https://migrate.doge.ceo/',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },

      {
        label: t('Website'),
        href: 'https://doge.ceo/',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Telegram'),
        href: 'https://t.me/DogeCEO_EN',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Twitter'),
        href: 'https://twitter.com/DogeCEOofficial',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
    ],
  },
  
]

export default config
